import ExtractPage from "../components/templates/ExtractPage"

export default function Extract() {
  return <ExtractPage />
}
